import { render, staticRenderFns } from "./Step_Passport.vue?vue&type=template&id=29c87ed4"
import script from "./Step_Passport.vue?vue&type=script&lang=js"
export * from "./Step_Passport.vue?vue&type=script&lang=js"
import style0 from "./Step_Passport.vue?vue&type=style&index=0&id=29c87ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports